import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Field, propTypes as fieldArrayFieldsPropTypes } from 'redux-form';

import { Button } from 'components/core/Button';
import FormItem from './FormItem';
import FormGroup from './FormGroup';

export function ReduxFormFieldArray({ array, className, fields, label }) {
	const addField = () => fields.push({});
	const removeField = (index) => () => fields.remove(index);
	return (
		<div className={classnames('field-array', className)}>
			{Children.toArray(
				fields.map((field, index) => (
					<div className="field-array-item">
						<FormGroup>
							{array.map((item) => (
								<FormItem key={item.name}>
									<Field
										name={`${field}.${item.name}`}
										id={`${item.name}-${index}`}
										label={item.label}
										placeholder={item.placeholder}
										component={item.component}
									/>
								</FormItem>
							))}
						</FormGroup>
						<Button
							onClick={removeField(index)}
							className="remove-field"
						>
							<span>Remove</span>
						</Button>
					</div>
				)),
			)}
			<Button
				link
				secondary
				className="add-field"
				onClick={addField}
			>
				{label}
			</Button>
		</div>
	);
}

ReduxFormFieldArray.propTypes = {
	array: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			placeholder: PropTypes.string,
			component: PropTypes.func.isRequired,
		}),
	),
	className: PropTypes.string,
	fields: PropTypes.oneOfType([
		PropTypes.shape(fieldArrayFieldsPropTypes),
		PropTypes.array,
	]),
	label: PropTypes.string.isRequired,
};

export default ReduxFormFieldArray;
